<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let imageSrc;
  export let isCategoryPage = false;
  export let categoryName;
  export let brandUrl = '';
  export let hitsCount = '';
  export let algoliaUrl;
  export let carouselRuleName = '';
  const dispatcher = createEventDispatcher();

  function brandCategoryClicked(algoliaQuery, categoryName, brandUrl, hitsCount, carouselRuleName) {
    dispatcher('brandCategoryClicked', {
      algoliaQuery,
      categoryName,
      brandUrl,
      hitsCount,
      carouselRuleName,
    });
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  class="product-category-container"
  class:category-brand-section={isCategoryPage}
  on:click={() => brandCategoryClicked(algoliaUrl, categoryName, brandUrl, hitsCount, carouselRuleName)}
>
  <img src={`${imageSrc}?fmt=auto&h=64`} alt={categoryName} />
  {#if !isCategoryPage}
    <h3>{categoryName}</h3>
  {/if}
</div>

<style lang="scss">
  @import '../../styles/colors.new.scss';

  .product-category-container {
    cursor: pointer;
    display: flex;
    width: 180px;
    padding: 12px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    aspect-ratio: 1;
    height: 119px;
    &.category-brand-section {
      flex-direction: row;
      width: 177px;
      height: 88px;
      gap: 12px;
    }
    img {
      height: 64px;
      aspect-ratio: auto;
      object-fit: contain;
    }
    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      color: $neutral-dark-01;
    }
  }
</style>
